import { LayoutDashboard, CreditCard, UserCheck, ShieldCheck, BarChart3, Settings, Mail, MonitorPlay, Smartphone } from "lucide-react";
import { ROUTES } from "@/constants/routes";

export const DASHBOARD_NAV = [
  { label: "Dashboard", to: ROUTES.dashboard, icon: LayoutDashboard, testId: "nav-dashboard", end: true },
  { label: "My Card", to: ROUTES.card, icon: CreditCard, testId: "nav-my-card" },
  { label: "Public Profile", to: ROUTES.profile, icon: UserCheck, testId: "nav-public-profile" },
  { label: "Email Signature", to: ROUTES.signature, icon: Mail, testId: "nav-email-signature" },
  { label: "Meeting Background", to: ROUTES.background, icon: MonitorPlay, testId: "nav-meeting-background" },
  { label: "Home Screen", to: ROUTES.homeScreen, icon: Smartphone, testId: "nav-home-screen" },
  { label: "Identity Assets", to: ROUTES.assets, icon: ShieldCheck, testId: "nav-identity-assets" },
  { label: "Analytics", to: ROUTES.analytics, icon: BarChart3, testId: "nav-analytics" },
  { label: "Settings", to: ROUTES.settings, icon: Settings, testId: "nav-settings", alsoActive: "/settings" },
];
